import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import { useSelections } from "../../context/Selections";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import QtdPDVsProduto from "./components/QtdPDVsProduto";
import AnalisePDVs from "./components/AnalisePDVs";
import PDVsFaltantes from "./components/PDVsFaltantes";
import AnaliseSKUs from "./components/AnaliseSKUs";
import { Footer } from "../../components/Footer/Footer";
import { OverviewCardSkeleton } from "../../components/Cards";
import { useOverviewData } from "../../hooks";

const OBJECT_IDS = {
  RANKING: "tjQzgaU",
};


function PCandSkinDesktop({ app }) {
  const { selections } = useSelections();
  const [nameUser, setNameUser] = useState("");
  const { isLoading } = useOverviewData(app);

  const getNameUser = useCallback(
    async (objectId) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value = res?.model?.layout?.style?.label;
          setNameUser(value);
        } catch (error) {
          console.error("Erro ao buscar nome do usuário:", error);
        }
      }
    },
    [app]
  );

  useEffect(() => {
    if (app) {
      getNameUser(OBJECT_IDS.USER_NAME);
    }
  }, [app, getNameUser, selections]);

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutWrapper>
          <Grid
            container
            flexDirection="column"
            justifyContent="flex-start"
            rowGap={2}
          >
            {isLoading ? (
              <Grid container spacing={2}>
                {/* First row - 2 columns */}
                <Grid item xs={12} md={4}>
                  <OverviewCardSkeleton variant="rectangle" />
                </Grid>
                <Grid item xs={12} md={8}>
                  <OverviewCardSkeleton variant="retangle" />
                </Grid>

                {/* Second row - 4 equal columns */}
                <Grid item xs={12} md={4}>
                  <OverviewCardSkeleton variant="retangle" />
                </Grid>
                <Grid item xs={12} md={8}>
                  <OverviewCardSkeleton variant="retangle" />
                </Grid>
              </Grid>
            ) : (
              <Grid item spacing={2} sx={{ marginBottom: "20px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4} className="container-tables-tops">
                    <QtdPDVsProduto app={app} />
                  </Grid>
                  <Grid item xs={12} md={8} className="container-tables-tops">
                    <AnalisePDVs app={app} />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4} className="container-tables-tops">
                    <PDVsFaltantes app={app} />
                  </Grid>
                  <Grid item xs={12} md={8} className="container-tables-tops">
                    <AnaliseSKUs app={app} />
                  </Grid>
                </Grid>
                <Grid item spacing={2}>
                  <Footer app={app} />
                </Grid>
              </Grid>
            )}
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

PCandSkinDesktop.propTypes = {
  app: PropTypes.object,
};


export default PCandSkinDesktop;
